var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4979 8.89207L20.3156 0H18.463L11.6749 7.72086L6.25324 0H0L8.19861 11.6753L0 21H1.85266L9.02109 12.8465L14.7468 21H21L12.4974 8.89207H12.4979ZM9.96039 11.7782L9.1297 10.6156L2.52019 1.36466H5.36576L10.6997 8.83044L11.5304 9.99304L18.4639 19.6974H15.6183L9.96039 11.7786V11.7782Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootIcon1);
export default __webpack_public_path__ + "static/media/foot_icon1.58e48f7f9dd4a0fc3ef3ce1079c660ea.svg";
export { ForwardRef as ReactComponent };